/**
 * The ONE "Unsaved changes — Stay / Leave" copy (RD-UI-009, KAN-580).
 *
 * Every create/edit drawer and typing pop-up asks this exact question before
 * it closes with unsaved work — through `useUnsavedChangesGuard` — and the
 * dashboard-level guards (tab leave, Employee drawer, Job detail) pass it to
 * `requestConfirmation`. Never word a second variant: the builders' footer
 * "Keep editing / Discard changes" bar is the only other discard surface, and
 * it is a deliberate, separate family (Builders Modern, 2026-09-27).
 */
export function buildUnsavedChangesConfirmArgs(intl) {
  return {
    title: intl.formatMessage({ id: 'field.unsavedChanges', defaultMessage: 'Unsaved changes' }),
    message: intl.formatMessage({
      id: 'field.unsavedChangesMessage',
      defaultMessage: 'You have unsaved changes. Leave without saving?',
    }),
    confirmLabel: intl.formatMessage({ id: 'field.leave', defaultMessage: 'Leave' }),
    cancelLabel: intl.formatMessage({ id: 'field.stay', defaultMessage: 'Stay' }),
    tone: 'default',
  };
}
